import { Box, CardContent, Skeleton, TableBody, TableCell, TableRow } from '@mui/material';
import { Card } from '../../../card/card.style';

import { CardTitle, InfoTitle, Table } from '../dialog.styles';

export const ReviewSummarySkeleton = () => (
  <Card>
    <CardContent style={{ paddingBottom: 0 }}>
      <CardTitle>
        Review Summary
        <span>
          <Skeleton variant="text" width={150} height={24} />
        </span>
      </CardTitle>
      <Table className="table-info" style={{ marginBottom: 0 }}>
        <TableBody>
          <TableRow>
            <TableCell style={{ width: '15%' }}>
              <InfoTitle>Rating:</InfoTitle>
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width={100} height={20} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ width: '15%' }}>
              <InfoTitle>Title:</InfoTitle>
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width="80%" height={20} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ width: '15%' }}>
              <InfoTitle>Review:</InfoTitle>
            </TableCell>
            <TableCell>
              <Skeleton variant="text" width="95%" height={34} />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Table className="table-info" style={{ marginBottom: 0 }}>
        <TableBody>
          <TableRow>
            <TableCell style={{ width: '15%' }}>
              <InfoTitle>Post to:</InfoTitle>
            </TableCell>
            <TableCell>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Skeleton variant="text" width={80} height={30} style={{ marginRight: 8 }} />
                <Skeleton variant="text" width={80} height={30} style={{ marginRight: 8 }} />
              </Box>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Table className="table-info" style={{ marginBottom: 0, width: '100%' }}>
        <TableBody>
          <TableRow>
            <TableCell style={{ width: '100%' }}>
              <InfoTitle>Feature Review</InfoTitle>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ width: '100%', padding: '0 13px' }}>
              <Skeleton variant="text" width="95%" height={34} />
              <Skeleton variant="text" width="95%" height={34} />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Table className="table-info" style={{ marginBottom: 0 }}>
        <TableBody>
          <TableRow>
            <TableCell>
              <InfoTitle>Reply Publicly:</InfoTitle>
              <Skeleton variant="rectangular" sx={{ marginTop: '10px', width: 'calc(100% - 32px)' }} height={90} />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: '0 10px 16px' }}>
        <Skeleton variant="rectangular" width={100} height={30} />
      </Box>
    </CardContent>
  </Card>
);
